import { toEnglishDigits } from '../../../report.utils';
import { RouteAnalysisRow, RouteDetailKind, RouteTableColumn, RouteTableAction, RouteReportModalState } from './route-analysis-report.models';

export const ANALYSIS_PAGE_SIZES = [10, 20, 50];
export const ANALYSIS_PAGE_SIZE = 20;
export const ROUTE_MODAL_IDS: Record<RouteDetailKind, string> = {
  'daily-summary': 'SummaryByDay_Modal', salary: 'SalarySummary_Modal',
  passengers: 'Func_Passenger_Modal', stations: 'intermediate-Station',
};
export function emptyRouteModalState(): RouteReportModalState {
  return { rows: [], columns: [], actions: [], subtitle: '', extraSummary: '', loading: false, hasError: false, errorMessage: '', hasRequestedData: false, requestKey: 0 };
}
export const ANALYSIS_ACTIONS: RouteTableAction[] = [
  { kind: 'map', title: 'نمایش مسیر روی نقشه', icon: 'fa-map-marker' },
  { kind: 'stations', title: 'ایستگاه‌های میانی', icon: 'fa-bus' },
];
export const DELETE_ROUTE_ACTION: RouteTableAction = { kind: 'delete', title: 'حذف', icon: 'fa-trash' };
export const STATION_MAP_ACTION: RouteTableAction = { kind: 'station-map', title: 'نمایش روی نقشه', icon: 'fa-map-marker' };
export function analysisColumns(type: string): RouteTableColumn[] {
  return [
    { field: 'strMobileType_strComment', title: 'نوع خودرو' },
    { field: 'strRoute_strName', title: 'مسیر' },
    { field: 'strDestinationStationName', title: 'مقصد' },
    { field: 'strSourceStationName', title: 'مبدأ' },
    { field: 'strDate', title: 'تاریخ' },
    { field: 'strSourceETime', title: 'ساعت خروج از مبدأ' },
    { field: 'strFullName', title: 'نام راننده' },
    ...(type === '21' ? [{ field: 'iCost', title: 'هزینه (ریال)', numeric: true, totalField: 'iCost', unit: 'ریال' }] : []),
    { field: 'strVehicleNo', title: 'پلاک' },
    { field: 'iPassengers', title: 'نفرات', action: 'passengers' },
    { field: 'strSourceSTime', title: 'مدت حضور در مبدأ' },
    { field: 'strDestinationSTime', title: 'ساعت ورود به مقصد' },
    { field: 'strTime', title: 'مدت سفر', totalField: 'iTime', divisor: 3600, unit: 'ساعت' },
    { field: 'fLength', title: 'پیمایش (km)', numeric: true, totalField: 'fLength', unit: 'کیلومتر' },
    { field: 'iStationPassed', title: 'تعداد ایستگاه میانی', numeric: true },
    { field: 'iPassengers', title: 'تعداد پرسنل سوار شده', numeric: true },
    { field: 'bSchedule', title: 'مطابق برنامه', boolean: true },
  ];
}
export function detailColumns(kind: RouteDetailKind, rows: RouteAnalysisRow[]): RouteTableColumn[] {
  if (kind === 'stations') return [
    { field: 'strDate', title: 'تاریخ' }, { field: 'strFullName', title: 'نام خودرو' },
    { field: 'iRoute_Station', title: 'کد ایستگاه' }, { field: 'strName', title: 'نام ایستگاه' },
    { field: 'strSTime', title: 'ساعت ورود' }, { field: 'strETime', title: 'ساعت خروج' },
    { field: 'strPresence', title: 'مدت حضور' }, { field: 'iOnboard', title: 'تعداد مسافر سوار شده', numeric: true },
    { field: 'iDisembarked', title: 'تعداد مسافر پیاده شده', numeric: true }, { field: 'bViolation', title: 'تخلف حضور', boolean: true },
  ];
  if (kind === 'passengers') return [
    { field: 'strPassenger_FullName', title: 'نام و نام خانوادگی' },
    { field: 'strUserManager_Chart_strComment', title: 'جایگاه سازمانی' },
    { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' }, { field: 'strDate', title: 'تاریخ' },
    { field: 'strTime', title: 'ساعت' }, { field: 'strName', title: 'نام ایستگاه' }, { field: 'strVehicleNo', title: 'پلاک خودرو' },
  ];
  if (kind === 'salary') return [
    { field: 'strFullName', title: 'نام راننده' }, { field: 'strRoute_strName', title: 'مسیر' },
    { field: 'strMobileType_strComment', title: 'نوع خودرو' }, { field: 'strSDate', title: 'از تاریخ' },
    { field: 'strEDate', title: 'تا تاریخ' }, { field: 'iCount', title: 'تعداد', numeric: true, totalField: 'iCount' },
    { field: 'iCost', title: 'کرایه (ریال)', numeric: true },
    { field: 'iAmount', title: 'مبلغ کارکرد (ریال)', numeric: true, totalField: 'iAmount', unit: 'ریال' },
  ];
  const keys = Array.from(new Set(rows.flatMap(row => Object.keys(row))));
  return [
    ...keys.filter(key => isNaN(Number(key)) && key !== 'جمع کل'),
    ...keys.filter(key => !isNaN(Number(key))).sort((a, b) => Number(a) - Number(b)),
    ...(keys.includes('جمع کل') ? ['جمع کل'] : []),
  ].map(field => ({ field, title: field, numeric: !isNaN(Number(field)) || field === 'جمع کل' }));
}
export const DETAIL_DEFINITIONS: Record<RouteDetailKind, { endpoint: string; title: string; loginReport: string }> = {
  stations: { endpoint: 'Route_StationsFunctionReport_List', title: 'ایستگاه‌های میانی طی‌شده', loginReport: 'intermediate-station' },
  passengers: { endpoint: 'Route_FunctionReport_Passenger_List', title: 'نفرات', loginReport: 'W22xs2RK' },
  'daily-summary': { endpoint: 'Route_FunctionReport_RouteServiceSummaryByDay', title: 'گزارش عملکرد براساس مسیر', loginReport: 'summary_ByDay' },
  salary: { endpoint: 'Route_FunctionReport_DriverSalarySummary', title: 'صورت حساب رانندگان', loginReport: 'route_SalarySummary' },
};
export function analysisCell(row: RouteAnalysisRow, column: RouteTableColumn): string | number {
  if (column.boolean) return row[column.field] ? 'بله' : 'خیر';
  if (column.numeric) return Number(row[column.field]) || 0;
  return String(row[column.field] ?? '');
}
export function analysisSearch(row: RouteAnalysisRow, columns: RouteTableColumn[]): string {
  return toEnglishDigits([...columns.map(column => analysisCell(row, column)), row['strPersonnelID'] ?? ''].join(' ')).trim().toLowerCase();
}
export function analysisTotal(rows: RouteAnalysisRow[], column: RouteTableColumn): number {
  return rows.reduce((sum, row) => sum + (Number(row[column.totalField!]) || 0), 0) / (column.divisor || 1);
}
